export default {
  //A
  "All rights reserved": "Todos los derechos reservados",
  Admin: "Administrador",
  Accepted: "Aceptado",
  Arrived: "Conductor llegó",
  "About the panel": "Sobre el panel",
  "Adapted to your needs": "Nos adaptamos a tus necesidades",
  "Adjust credit": "Ajustar crédito",
  "Update credit": "Ajustar crédito",
  "Credit limit adjustment": "Ajuste de límite de crédito",
  "Credit limit adjustment history": "Historial de ajustes de límite de crédito",
  "Track changes made to the credit limits of your associated panels.":
    "Consulta los cambios realizados en el límite de crédito de tus paneles asociados.",
  "Panel ID": "Panel ID",
  "Associated panel": "Panel asociado",
  "Date and time": "Fecha y hora",
  "Previous limit": "Límite anterior",
  "New limit": "Nuevo límite",
  "Adjustment type": "Tipo de ajuste",
  "Adjustment source": "Responsable del ajuste",
  Increase: "Aumento",
  Decrease: "Reducción",
  "No changes": "Sin cambios",
  "Sales executive": "Ejecutivo de ventas",
  "Panel administrator": "Administrador del panel",
  "api partner": "api partner",
  Panel: "Panel",
  "Modify credit limit": "Modificar límite de crédito",
  "Assigned amount": "Monto asignado",
  "Available to distribute": "Disponible",
  "Credit limit updated successfully": "Límite de crédito actualizado exitosamente",
  "Error fetching available credit limit": "Error al obtener el límite de crédito disponible",
  "Error updating credit limit": "Error al actualizar el límite de crédito",
  "Error fetching credit distribution": "Error al obtener la distribución de crédito",
  NEW_CREDIT_LIMIT_EXCEESS_MASTERS:
    "El nuevo límite de crédito excede el límite de crédito del master",
  CORPORATE_NOT_FOUND: "El panel no fue encontrado",
  "Arrange trips for your clients": "Agenda viaje para tus clientes",
  Additionally: "Adicionalmente",
  "Also driver's availability near the origin point of the trip":
    "También se mostrará la disponibilidad cercana al punto de origen del viaje de conductores",
  ACTION: "ACCIÓN",
  ACCIÓN: "ACCIÓN",
  Apply: "Aplicar",
  "Available balance": "Balance",
  AMOUNT: "MONTO",
  "AGREGADO/RESTADO": "AGREGADO/RESTADO",
  "ADD/CUT": "AGREGADO/RESTADO",
  "Add to payroll": "Agregar a nómina",
  Active: "Activo",
  Activo: "Activo",
  Suspendido: "Suspendido",
  "Activate overdraft": "Activar sobregiro",
  "Activate user": "Activar usuario",
  Approved: "Aprobado",
  All: "Todos",
  Assignations: "Asignaciones",
  "Additionally, our monitoring team is always at willingness to deal with any incident":
    "Adicionalmente nuestro equipo de monitoreo está siempre a disposición para atender cualquier incidencia",
  "Also driver's availability near the origin point of the parcel":
    "También se mostrará la disponibilidad cercana al punto de origen del viaje de conductores",
  Accept: "Aceptar",
  Approve: "Aprobar",
  and: "y",
  automated_payments: "Recargas automatizadas",
  automated_zelle: "Zelle automatizado",
  automated_pago_movil: "Pago móvil automatizado",
  // API
  api_credentials_generate_token: "Generar token",
  api_credentials_is_allowed_corporate_api_partner:
    "Acceso global a API partners corporativos permitido",
  api_credentials_is_corporate_api_partner:
    "Acceso particular a API partners corporativos permitido",
  api_credentials_is_allowed_corporate_shipment_api:
    "Acceso particular a envíos de API partners corporativos permitido",
  api_credentials: "Credenciales",
  api_credentials_tooltip:
    "En esta vista puedas revisar y editar tus credenciales de la API",
  api_credentials_active_api: "Permisos y accesos activos de la API",
  api_credentials_active_api_tooltip:
    "En esta sección puedes revisar permisos y accesos activos de la API",
  api_permissions_table_header: "Permiso",
  api_active_table_header: "Activo",
  api_credentials_is_allowed_corporate_api_partner_tooltip:
    "Este permiso indica si Ridery ha dado accesso a su API a sus API Partners",
  api_credentials_is_corporate_api_partner_tooltip:
    "Este permiso indica si el Panel Corporativo tiene acceso particual a la API de Ridery para API Partners",
  api_credentials_is_allowed_corporate_shipment_api_tooltip:
    "Este permiso indical si el Panel Corporativo tiene acceso particular a la API de Ridery para API Partners para Envíos",
  api_credentials_token: "Token",
  api_credentials_token_tooltip:
    "En esta sección puedes revisar y generar un token utilizado para acceder a la API para API Partners de Ridery",
  api_credentials_token_label: "Token para autorización de API",
  api_credentials_webhook_title: "Webhook",
  api_credentials_webhook_title_tooltip:
    "En esta sección puedes establecer un Webhook para recibir notificaciones de cambios de status de viajes/envíos que hayas realizado siendo API Partner",
  api_credentials_send_webhook: "Enviar Webhook",
  api_credentials_send_webhook_deactivate: "Desactivar Webhook",
  api_documentation: "Documentación",
  api_documentation_tooltip:
    "En esta vista puedes revisar la documentación para API Partners",
  //B
  Basic: "Básico",
  Balance: "Balance",
  CorporateInvoices: "Facturas",
  CreditDistribution: "Distribución de crédito",
  IslrRetention: "Retenciones",
  "Back to the panel": "Volver al panel",
  By: "Por",
  "Book you work trips": "Agenda tus viajes corporativos",
  "Book a demonstration with our team":
    "Agenda una demostración con nuestro equipo",
  "Balance top-up request": "Solicitud de recarga de balance",
  "By admin": "Por admin",
  BALANCE: "SALDO",
  "Billing Info": "Datos de facturación",
  "Billing info text": "Completa esta información para continuar recibiendo la factura de cada servicio. ¡Es rápido y seguro!",
  "Billing name": "Razón social",
  "Billing name placeholder": "Ingresa tu razón social",
  "Billing email": "Correo electrónico de facturación",
  "Billing email placeholder": "Ingresa tu correo electrónico",
  "Billing rif letter": "Tipo",
  "Billing rif no": "Número de documento",
  "Billing rif placeholder": "Ingresa tu documento",
  "Billing address": "Dirección fiscal",
  "Billing address placeholder": "Ingresa tu dirección fiscal",
  "Billing save": "Guardar datos",
  "Billing success": "Información de facturación guardada exitosamente",
  "Billing failure": "Error al guardar la información de facturación",
  "By clicking here you can refresh the map":
    "Al clickear acá puedes refrescar el mapa",
  "By clicking you can refresh the nearby providers in the map":
    "Al clickear acá puedes refrescar los conductores cercanos en el mapa",
  Brand: "Marca",
  "BALANCE INICIAL": "BALANCE INICIAL",
  "BALANCE FINAL": "BALANCE FINAL",
  "BALANCE INICIAL (CORPORATIVO)": "BALANCE INICIAL",
  "BALANCE FINAL (CORPORATIVO)": "BALANCE FINAL",
  "BALANCE INICIAL (USUARIO)": "BALANCE INICIAL",
  "BALANCE FINAL (USUARIO)": "BALANCE FINAL",
  bulk: {
    unitary: "Unitariamente",
    bulk: "En lote",
  },
  //C
  "Create a new Trip": "Crear un nuevo viaje",
  Corporate: "Corporativo",
  clear: "clear",
  Completed: "Completado",
  "Partially completed": "Parcialmente completado",
  Cancelled: "Cancelado",
  Coming: "En camino",
  "Cancelled by user": "Cancelado por usuario",
  "Corporate Panel": "Panel Corporativo",
  "Corporate Panels": "Paneles corporativos",
  "Corporate Panels Totals": "Total paneles corporativos",
  Contact: "Contacto",
  "Control your spending": "Controla tus gastos",
  Contactverb: "Contactar",
  "Contact form": "Formulario de contacto",
  "Can I book a trip or make reservations for another person?":
    "¿Puedo pedir un viaje o hacer reservas para una persona que no esté en mi panel?",
  "Create trip": "Crear viaje",
  "Current and scheduled trips": "Viajes en curso y programados",
  CONDUCTOR: "CONDUCTOR",
  COST: "COSTO",
  COSTO: "COSTO",
  "Cancel trip": "Cancelar viaje",
  Cancel: "Cancelar",
  "Charge of this trip": "Cargo del viaje",
  "Charge of this parcel": "Cargo del envío",
  Card: "Tarjeta",
  "CORREO ELECTRÓNICO": "CORREO ELECTRÓNICO",
  "Contact corporativo@ridery.app requesting the invoice of the recharge previously made, or failing that, to the fill out the payment form select ''YES'' in the field of invoice.":
    "Escribe un correo a corporativo@ridery.app solicitando la factura de la recarga previamente realizada, o en su defecto, al llenar el formulario de pago selecciona ''SI'' en el campo de factura.",
  "Create a new Parcel": "Crear un nuevo envío",
  "Current and scheduled parcel": "Envíos en curso y programados",
  Clear: "Limpiar",
  copy_trip_details: "Copiar enlace de detalles del viaje",
  copy_trip_details_success: "Detalles del viaje copiados exitósamente",
  copy_parcel_details: "Copiar enlace de detalles del envío",
  copy_parcel_details_success: "Detalles del envío copiados exitósamente",
  CorporatePanels: "Paneles corporativos",
  corporate_master_assign: "Asignación panel master",
  CorporatePanel: "Panel corporativo",
  contact_us: "Contáctanos",
  "Credit distribution": "Distribución de crédito",
  //D
  Dashboards: "Principal",
  "Destination address": "Dirección de destino",
  "Date and Time": "Fecha y Hora",
  "Dirección de origen": "Dirección de origen",
  "Dirección de destino": "Dirección de destino",
  DISTANCIA: "DISTANCIA",
  DURACIÓN: "DURACIÓN",
  "DATE AND TIME": "FECHA Y HORA",
  "DIRECCIÓN DE ORIGEN": "DIRECCIÓN DE ORIGEN",
  "DIRECCIÓN DE DESTINO": "DIRECCIÓN DE DESTINO",
  "DESTINATION ADDRESS": "DIRECCIÓN DE DESTINO",
  "Do you want to cancel the trip?": "¿Quiere cancelar el viaje?",
  "Date range": "Rango de fechas",
  "Deactivate overdraft": "Desactivar sobregiro",
  "Date issued": "Fecha emitida",
  "Date paid": "Fecha abonada",
  Discount: "Descuento",
  Details: "Detalles",
  "Driver's app certification": "Examen sobre uso correcto de la plataforma",
  Delete: "Eliminar",
  "Driver Waiting": "Conductor esperando",
  "Driver Info": "Información del conductor",
  //E
  Email: "Correo electrónico",
  "Enter your email and we'll send you instructions to reset your password":
    "Coloca tu correo electrónico y te enviaremos las instrucciones para restablecer tu contraseña",
  "Email sent": "Correo electrónico enviado",
  "Enter your new password": "Coloca tu nueva contraseña",
  "Error creating trip": "Error creando viaje",
  Export: "Exportar",
  EMAIL: "CORREO ELECTRÓNICO",
  "Eliminate user": "Eliminar usuario",
  "Efficiency in the execution of your budget.":
    "Garantiza eficiencia en la ejecución de tu presupuesto.",
  "Excess": "Saldo a favor",
  "Excess tooltip": "Los saldos en bolívares no son indexados.",
  "Excess auto": "Se aplicará automáticamente en tu próxima factura",
  //F
  "Forgot Password?": "¿Olvidó su contraseña?",
  OTHERS: "OTROS SERVICIOS",
  FINANCIAL: "FINANZAS",
  FAQ: "Preguntas y Respuestas",
  FAQ2: "Preguntas frecuentes",
  "Fecha y hora": "Fecha y hora",
  "FECHA Y HORA": "FECHA Y HORA",
  "Find your workers inside Ridery's app to add them to your payroll":
    "Find your workers inside Ridery's app to add them to your payroll",
  "For your safety": "Por tu seguridad",
  "For your comfort": "Para tu comodidad",
  "For increased efficiency": "Para mayor efectividad",
  fullName: "Nombre completo",
  //G
  GoBack: "Volver",
  "Get quote": "Cotizar",
  "Get quick quote": "Cotización rápida",
  "Go to page": "Ir a la página",
  "Good Morning!": "¡Buenos días!",
  "Good Afternoon!": "¡Buenas tardes!",
  "Good Evening!": "¡Buenas noches!",
  //H
  History: "Historial",
  "History ": "Historial ",
  "How is a trip's fare calculated?": "¿Cómo se calcula el precio de un viaje?",
  "How do I pay for my business trips?": "¿Cómo pago los viajes de mi empresa?",
  "How does Ridery take care of the safety of its passengers?":
    "¿Cómo cuida Ridery la seguridad de sus pasajeros?",
  "How do I receive invoices for my company's trips?":
    "¿Cómo recibo facturas de los viajes de mi empresa?",
  "How can I control my payroll expenses?":
    "¿Cómo puedo controlar los gastos de mi nómina?",
  "How to request the invoice prior to recharging?":
    "¿Cómo solicitar la factura previa a la recarga?",
  hide_user_panel: "Ocultar panel de usuario",
  show_user_panel: "Mostrar panel de usuario",
  //I
  Inmediate: "Inmediato",
  "Invalid credentials": "Credenciales inválidas",
  "In this view you can visualize the trips in course on the map":
    "En esta vista puedes visualizar los viajes en curso en el mapa",
  "In this map view you can visualize the waypoints origin and destination":
    "En esta vista de mapa puedes visualizar los puntos de origen y destino",
  "In this form you can create a new trip for now or scheduled":
    "En este formulario puedes crear un nuevo viaje para ahora o programado",
  "If you need to adjust coordinates for a trip you can use the source and destination pointers for that purpose":
    "Si necesitas ajustar coordenadas para un viaje puedes tilizar los punteros de origen y destino para ese fin",
  "In this table you can consult all current and scheduled trips associated with your corporate panel":
    "En esta tabla puedes consultar todos los viajes en curso y programados asociados a tu panel corporativo",
  ID: "ID",
  "ID USUARIO": "ID USUARIO",
  Inactive: "Inactivo",
  Invoice: "Nota de servicio",
  "Invoice to": "Nota de servicio para",
  "in a": "de manera",
  "Ideal balance between cost control and self-management.":
    "Obtén el balance ideal entre control de gastos y autogestión.",
  "In this view you can visualize the parcels in course on the map":
    "En esta vista puedes visualizar los envíos en curso en el mapa",
  "In this form you can create a new parcel for now or scheduled":
    "En este formulario puedes crear envíos instantáneos o programados",
  "If you need to adjust coordinates for a parcel you can use the source and destination pointers for that purpose":
    "Si necesitas ajustar coordenadas para un envío puedes tilizar los punteros de origen y destino para ese fin",
  "in corporate panels": "en paneles corporativos",
  //Q
  "quick, confortable and secure way": "rápida, cómoda y segura",
  //L
  Login: "Iniciar sesión",
  Logout: "Cerrar Sesión",
  Landing: "Bienvenido",
  "Last name": "Apellido",
  "Limit amount": "Monto límite",
  Link: "Enlace",
  "Live monitoring, accompaniment and assignment 24 hours a day of the day, 7 days a week with a response time from 3 to 7 minutes.":
    "monitoreamos, acompañamos y asignamos viajes 24/7, con un tiempo de respuesta entre 3 y 7 minutos aproximadamente.",
  "Lo sentimos, Ridery no presta servicio en esa dirección de origen":
    "Lo sentimos, Ridery no presta servicio en esa dirección de origen",
  //M
  "More information": "Más información",
  "more panels": "paneles más",
  "Monitor your trips": "Monitorea tus viajes",
  MONTO: "MONTO",
  "Monitoreo (Viajes) Teléfono": "Monitoreo (Viajes) Teléfono",
  "Monitoreo (Viajes) Correo electrónico":
    "Monitoreo (Viajes) Correo electrónico",
  "must accept the request in Ridery's user app":
    "debe aprobar la solicitud en la aplicación de usuario de Ridery",
  Model: "Modelo",
  "Movements": "Movimientos",
  "Movement trip": "Cargo por viaje",
  "Movement admin add": "Admin agregó saldo",
  "Movement admin cut": "Admin retiró saldo",
  Multistop: "Multiparadas",
  multistop_quoted: "Multiparadas cotizadas",
  multistop_quoted_tooltip:
    "En esta vista puedes consultar las multiparadas cotizadas, aprobar o eliminar. Las multiparadas no aprobadas expiran 15 minutos antes de la hora programadas",
  multi_stop_new: "Nueva cotización de multiparada",
  multistop_delete_modal: "¿ Quieres eliminar la cotización ?",
  multistop_total_stop: "Total parada",
  multistop_time_stop: "Total tiempo",
  multistop_distance_stop: "Total distancia",
  multistop_new_map_tooltip:
    "En esta vista de mapa puedes consultar los puntos de multiparada",
  multiStopNew: "Nueva multiparada",
  multistop_add: "Agregar",
  multistop_add_tooltip:
    "En este formulario puedes ir agregando paradas a un viaje multiparada",
  multistop_stop: "Parada",
  multistop_origin: "Origen",
  multistop_full_1: "Has alcanzado el máximo de paradas permitidas",
  multistop_full_2: "Puedes consultar el listado y resumen de paradas",
  multistop_list: "Listado de paradas",
  multistop_list_tooltip:
    "En esta tabla puedes consultar el listado de paradas de un viaje multiparada",
  multistop_total_resume: "Resumen multiparada",
  multistop_total_resume_tooltip:
    "En esta tabla puedes consultar el resumen de la multiparada",
  multistop_total_quote: "Cotizar multiparada",
  multi_stop: "Multiparada",
  multistop_show_quote_title: "Detalle de cotización (Multiparada)",
  multistop_show_quote_title_tooltip:
    "En esta vista puedes observar el detalle de una cotización de una multiparada",
  multistop_approve: "Aprobar cotización de multiparada",
  multistop_map_view: "Mapa del Multiparada",
  multistop_quote_success: "Multiparada cotizada satisfactoriamente",
  MultistopShow: "Detalle de viaje multiparada",
  manual_top_up_request: "Recargas manuales",
  manual_top_up_pending_table: "Recargas manuales esperando validación",
  manual_top_up_pending_table_tooltip:
    "En esta vista puedes consultar tus recargas manuales esperando validación",
  manual_payments_pending_see_details: "Ver detalles",
  //N
  "New Trip": "NUevo Viaje",
  "Not corporate": "No corporativo",
  Name: "Nombre",
  "Nombre y apellido": "Nombre y apellido",
  "No driver": "Sin conductor",
  NAME: "NOMBRE",
  NOMBRE: "NOMBRE",
  Note: "Nota",
  "Not approved": "No aprobado",
  "NON FISCAL": "NO FISCAL",
  "Manage your trips": "Gestiona tus viajes",
  NOTA: "NOTA",
  "New Parcel": "Nuevo Envío",
  no: "No",
  //O
  "Origin address": "Dirección de origen",
  "Our clients": "Nuestros clientes",
  "Our sales team is capacitated to show you a demo with the whole potential of the panel":
    "Conoce a profundidad los beneficios que tenemos para tu empresa, colaboradores y clientes.",
  "Obligatory field": "Campo obligatorio",
  Operator: "Operadora",
  Overdraft: "Sobregiro",
  "ORIGIN ADDRESS": "DIRECCIÓN DE ORIGEN",
  "ORIGEN DE TRANSACCIÓN": "ORIGEN DE TRANSACCIÓN",
  OVERDRAFT: "SOBREGIRO",
  "Optimize your time": "Optimiza tu tiempo",
  "Our drivers must pass a selection process of 4 stages:":
    "Aseguramos un proceso robusto de certificación de conductores y vehículos, y adicionalmente, nuestro equipo de monitoreo está siempre a disposición para atender cualquier necesidad que se presente.",
  "Our operators are 24 hours for you! Communicate for the following means for any incident or inconvenience presented:":
    "¡Nuestros operadores están 24 horas para tí! Comunícate por los siguientes medios para cualquier incidencia o inconveniente presentado: ",
  "Our trips are calculated based on a fixed rate per fleet selected being able to have various surcharges (time of day, traffic conditions, etc) if applicable.":
    "Tomamos como base una tarifa fija por flota seleccionada, sobre la cual pueden aplicar variaciones dependiendo del horario, tráfico, clima, entre otros factores.",
  //P
  "Panel users": "Usuarios en nómina",
  "Panel balance": "Balance en nómina",
  "Panel status": "Estatus del panel",
  "Panel limit": "Límite de crédito",
  "Panel available": "Crédito disponible",
  "Panel consumed": "Crédito consumido",
  "Panel active": "Facturas vigentes",
  "Panel overdue": "Facturas vencidas",
  "Panel outstanding": "Monto pendiente",
  "Panel action": "Acción",
  "Panels associated": "Paneles asociados",
  "Panels active": "Paneles activos",
  "Panels suspended": "Paneles suspendidos",
  "Panels inactive": "Paneles inactivos",
  "Panels suspended tooltip": "Paneles con servicio restringido por facturas vencidas o por alcanzar el límite de crédito.",
  "Panels inactive tooltip": "Paneles desactivados que no pueden operar.",
  payment_accounts_title: "Confirma tus pagos más rápido",
  payment_accounts_subtitle:
    "Agrega las cuentas bancarias desde las que sueles pagarnos. Así reconocemos y acreditamos tus transferencias con mayor rapidez, sin esperas para confirmar cada pago.",
  payment_accounts_security_notice:
    "Solo necesitamos el número de cuenta. No pedimos claves, saldos ni datos del titular.",
  payment_accounts_field_label: "Cuenta",
  payment_accounts_add: "+ Agregar cuenta",
  payment_accounts_submit: "Guardar",
  payment_accounts_no_national_transfer: "No pago con transferencia nacional",
  payment_accounts_success: "Cuentas guardadas correctamente",
  payment_accounts_error: "No se pudieron guardar las cuentas",
  payment_accounts_invalid:
    "Ingresa al menos una cuenta bancaria de 20 dígitos",
  "Please sign-in to your account and manage your trips":
    "Inicia sesión en tu cuenta y administra tus viajes",
  Password: "Contraseña",
  Profile: "Perfil",
  "Please check your email": "Por favor revisa tu correo electrónico",
  PasswordConfirm: "Confirmar contraseña",
  "Password reset": "Contraseña restablecida",
  Provider: "Conductor",
  "Provider detail error": "Error cargando detalles del conductor",
  Payroll: "Nómina",
  PROVIDER: "CONDUCTOR",
  PHONE: "TELÉFONO",
  Print: "Imprimir",
  "Psychotechnical evaluation": "Evaluación psicotécnica integral",
  "Psycho-technical evaluation, vehicle certification (aesthetics and mechanical), up-to-date legal documentation and final exam of app approval":
    "Evaluación psicotécnica, certificación del vehículo (estética y mecánica), documentación legal al día y examen final de aprobación de la app",
  "Plate number": "Placa",
  provider_name: "Nombre de conductor",
  Phone: "Teléfono",
  "Phone no": "Número de teléfono",
  PARCELS: "ENVÍOS",
  "Parcel Type": "Tipo de envío",
  "Parcel now": "Instantáneo",
  "Parcel responsible user": "Usuario responsable del envío",
  "Parcel history": "Historial de envíos",
  "PARCEL ID": "ID DE ENVÍO",
  "ID DE ENVÍO": "ID DE ENVÍO",
  parcel_receives_tooltip: "Esta persona sería contactada por el conductor",
  parcel_receiver: "¿Quién recibe tu envío?",
  parcel_textarea: "Detalles adicionales del envío",
  parcel_textarea_error:
    "Detalles adicionales deben ser 150 caracteres o menos",
  parcel_create: "Crear envío",
  parcel_created: "Envío creado exitosamente",
  parcel_cancel: "Cancelar envío",
  parcel_cancel_modal: "¿Quieres cancelar el envío?",
  parcel_details: "Detalles de envío",
  parcel_details_table: "Quien recibe el envío",
  parcelHistory: "Historial de envíos",
  parcel_table_running_tooltip:
    "En esta tabla puedes consultar todos los envíos en curso y programados asociados a tu panel corporativo",
  Parcels: "Envíos",
  ParceltooltipHistoryUser:
    "En esta vista puedes consultar los envíos realizados del usuario con el panel corporativo",
  parcel_more_info: "Políticas",
  ParcelGuide: "Políticas de envío",
  parcel_package_size: "Tamaño del paquete",
  parcel_package_mass: "Kilos permitidos",
  parcel_package_examples: "Puedes enviar este tipo de paquetes:",
  parcel_view_map_title: "Mapa del envío",
  parcel_view_map_completed_tooltip:
    "En esta vista puedes visualizar el recorrido aproximado de un envío completado entre punto de origen y destino",
  parcel_view_map_completed_tooltip2:
    "En esta vista puedes visualizar el estado en mapa de un envío en curso (si aplica) y los puntos de origen y destino",
  parcel_cancelled: "Envío cancelado exitosamente",
  parcel_cancelled_error: "Error cancelando envío",
  parcel_multistop_add_tooltip:
    "En este formulario puedes ir agregando paradas a un envío multiparada",
  parcel_multistop_list_tooltip:
    "En esta tabla puedes consultar el listado de paradas de un envío multiparada",
  person_is_contact: "Esta persona será contactada por el conductor",
  pago_movil_automatizado_tooltip:
    "Recarga tu balance corporativo con nuestro nuevo método de pago móvil automatizado",
  pago_movil_new: "Nuevo",
  ParcelMultistop: "Envíos multiparadas",
  parcelMultiStopNew: "Nuevo envío multiparadas",
  parcelMultiStopShow: "Detalle de envío multiparadas",
  parcel_continue: "Continuar",
  parcel_i_send: "Envía",
  parcel_i_receive: "Recibe",
  parcel_textarea_1_send: "Instrucciones en el origen",
  parcel_textarea_1_receive: "Instrucciones en el destino",
  parcel_data_person_send: "Datos de la persona que recibe",
  parcel_data_person_receive: "Datos de la persona que entrega",
  parcel_user_full_name: "Nombre y apellido",
  parcel_textarea_2_send: "Instrucciones en el destino",
  parcel_textarea_2_receive: "Instrucciones en el origen",
  parcel_textarea_package: "Descripción del paquete",
  parcel_package: "Paquete",
  parcel_package_image: "Imagen del paquete",
  parcel_upload_image: "Cargar imagen",
  parcel_prohibited_items: "Artículos prohíbidos",
  parcel_prohibited_items_shipments: "en nuestros envíos",
  parcel_prohibited_fireamrs: "Armas de fuego",
  parcel_prohibited_substances: "Sustancias ilícitas",
  parcel_prohibited_cash: "Dinero en efectivo",
  parcel_prohibited_waste: "Basura Tóxica",
  parcel_prohibited_lingots: "Lingotes",
  parcel_prohibited_fireworks: "Fuegos artificiales",
  parcel_prohibited_insecticides: "Insecticidas",
  parcel_shipment_summary: "Resumen de envío",
  parcel_quote_origin: "Origen",
  parcel_not_defined_remittent: "No definido",
  parcel_image_error_size: "La imagen debe ser menor a 5mb",
  parcel_image_error_required: "La imagen es requerida",
  parcel_quote_sender: "Pesona que envía",
  parcel_quote_sender_phone: "Teléfono",
  parcel_quote_instructions_on_origin: "Instruccciones en el origen",
  parcel_quote_destination: "Destino",
  parcel_quote_receiver: "Persona que recibe",
  parcel_quote_recoiver_phone: "Teléfono",
  parcel_quote_instructions_on_destination: "Instruccciones en el destino",
  parcel_quote_package_photo: "Foto del paquete",
  parcel_quote_package_description: "Descripción del paquete",
  parcel_parcel: "Envío",
  //Q
  "Quick quote": "Cotización rápida",
  //R
  REQUESTS: "VIAJES",
  "Running trips": "Viajes en curso ",
  "Realtime map": "Mapa",
  "Reset your password": "Resestablezca su contraseña",
  "Results per page": "Resultados por página",
  "REMAINING BALANCE": "SALDO RESTANTE",
  "Ridery's Corporate team": "Equipo de Ridery Corporativo",
  "Ridery Contact": "Contacto Ridery",
  "Ridery Corporate": "Ridery Corporativo",
  "Request a ride in less than 10 minutes.":
    "Solicita cualquier traslado en menos de 10 minutos.",
  "Refresh table": "Refrescar tabla",
  "Refresh map": "Refrescar mapa",
  "Running parcels": "Envíos en curso",
  //S
  Scheduled: "Programado",
  Started: "Viaje iniciado",
  Send: "Enviar",
  "Service type": "Tipo de servicio",
  Search: "Buscar",
  "Search by...": "Buscar por...",
  STATUS: "STATUS",
  "SALDO RESTANTE": "SALDO RESTANTE",
  Status: "Estatus",
  SALDO: "SALDO",
  SOBREGIRO: "SOBREGIRO",
  "Simultaneously move your collaborators or clients.":
    "Mueve simultáneamente a tus colaboradores o clientes.",
  "Schedule a meeting with our team": "Agenda una reunión con nosotros",
  Sobredemanda: "Sobredemanda",
  Service: "Servicio",
  SERVICIO: "SERVICIO",
  special_trip: "Viaje especial",
  //T
  "Trip Type": "Tipo de Viaje",
  Telephone: "Teléfono",
  "Travel now": "Viajar ahora",
  "Tipo de viaje": "Tipo de viaje",
  "Tipo de usuario": "Tipo de usuario",
  "Tipo de servicio": "Tipo de servicio",
  "Trip created successfully": "Viaje creado exitosamente",
  "TRIP ID": "ID VIAJE",
  "Trip cancelled successfully": "Viaje cancelado con éxito",
  "Trip history": "Historial de viajes",
  tooltipHistory:
    "En esta vista puedes consultar el historial de viajes, filtrar y exportar .xls",
  tooltipBalance:
    "En esta vista puedes ver las diferentes operaciones sobre tu balance",
  "Transaction origin": "Origen de Transacción",
  "TRANSACTION ORIGIN": "ORIGEN DE TRANSACCIÓN",
  tooltipUsers1:
    "En esta vista puedes consultar tu nómina y realizar operaciones básicas de administración como:",
  tooltipCorporatePanels1:
    "En esta vista puedes consultar tu nómina de panales corporativos y realizar operaciones básicas de administración como:",
  tooltipUsers2:
    "Agregar usuarios, administarar sobregiros, agregar balance, eliminar usuarios",
  tooltipCorporatePanels2: "Agregar balance o ver paneles corporativos",
  "Total master": "Límite total del máster",
  "Total master tooltip": " Límite establecido junto a tu ejecutivo. Para modificarlo, comunícate con él.",
  TELÉFONO: "TELÉFONO",
  "Thank you for choosing us": "Gracias por preferirnos",
  Tax: "Impuesto",
  "This receipt does not represent a fiscal invoice":
    "Esta nota de servicio no representa una factura fiscal",
  "Trip map": "Mapa del viaje",
  tooltipTripMap:
    "En esta vista puedes visualizar el recorrido aproximado de un viaje completado entre punto de origen y destino",
  tooltipTripMap2:
    "En esta vista puedes visualizar el estado en mapa de un viaje en curso (si aplica) y los puntos de origen y destino",
  "Trip ID": "ID viaje",
  "Trip ID must be an integer": "El ID del viaje debe ser un número entero",
  "Provider name": "Nombre del conductor",
  Trips: "Viajes",
  tooltipUserAssign:
    "En esta vista puedes consultar los movimientos que afectan el saldo del usuario.",
  "Through our toolset": "A través de nuestras herramientas",
  "To enter our fleet drivers must pass a 4-stage selection process":
    "todo conductor de la flota Ridery pasa por un arduo proceso de certificación que contempla 4 etapas:",
  "Total users": "Total usuarios",
  "Trip in couse": "Viaje en curso",
  tooltipHistoryUser:
    "En esta vista puedes consultar los viajes realizados del usuario con el panel corporativo",
  "This input is autocomplete": "Este campo es autocompletado",
  tooltipHistoryParcel:
    "En esta vista puedes consultar el historial de envíos del panel",
  TripInfo: "Información",
  trip: {
    trip_resume: "Resumen de viaje",
  },
  topUps: "Recargas",
  tooltipTopUps:
    "Aquí puedes escoger un método de pago para hacer una recarga de balance corporativo",
  //U
  "used": "Utilizado",
  "Use toggle": "Usar {balance} para el viaje",
  "Use user": "saldo del usuario",
  "Use corporate": "crédito del panel",
  "Use tooltip off":
    "Al momento de crear el viaje para el usuario corporativo {user}, el costo del mismo será debitado de su {uBalance_text} ({uBalance_value}), o de su {overdraft}.",
  "Use tooltip on":
    "El costo de este viaje se descontará del crédito del panel corporativo ({credit}). El saldo del usuario no se verá afectado.",
  USERS: "USUARIOS",
  User: "Usuario",
  Users: "Usuarios",
  "User type": "Tipo de usuario",
  unassigned: "Sin asignar",
  unique_id: "ID Viaje",
  user_first_name: "Nombre de usuario",
  "User name": "Nombre de usuario",
  USER: "USUARIO",
  USUARIO: "USUARIO",
  "User amount": "Monto usuario",
  "USER ID": "ID USUARIO",
  "Up-to-date legal documentation":
    " Comprobación de documentos legales al día",
  "User does not have sufficient balance or there isn't enough overdraft":
    "Usuario no posee saldo suficiente o no se dispone de sobregiro suficiente",
  user_wallet: "Saldo",
  userWallet: "saldo",
  user_found_db_ridery: "Usuario encontrado en la base de datos de Ridery",
  user_found_db_ridery_filling: "Rellenando automáticamente los campos",
  //V
  ViewMap: "Ver mapa",
  "View user": "Ver usuario",
  "View provider": "Ver conductor",
  "View map": "Ver mapa",
  "View invoice": "Ver nota de servicio",
  "Vehicle certification (aesthetics and mechanics)":
    "Revisión estética y mecánica del vehículo",
  Vehicle: "Vehículo",
  variable_tariffs: "Nuestras tarifas pueden variar",
  "View corporate panel": "Ver panel corporativo",
  "Panel view": "Ver panel",
  //W
  "Welcome!": "¡Bienvenido!",
  Waiting: "En espera",
  "We've sent an email to": "Hemos enviado un correo electrónico a",
  "Welcome again": "Bienvenido de nuevo",
  "Waiting for approval": "Esperando aprobación",
  "We are the app that modernizes your business mobility":
    "Somos la app que moderniza la movilidad de tu empresa",
  "We have an extensive fleet of vehicles, ranging from the most economical to passenger buses in the whole national territory.":
    "contamos con una extensa flota de vehículos, desde una moto hasta vans de pasajeros dispuestas para trasladarte por todo el territorio nacional.",
  "We have the following means for you to contact us. Our team will gladly assist you.":
    "Nuestro equipo está dispuesto a asistir cualquier requerimiento. Disponemos principalmente de dos canales para atender tus consultas o dudas.",
  "What should I do if I file an incident with my app?":
    "¿Qué debo de hacer si presento una incidencia con mi app?",
  //Y
  "You can log back in": "Puedes volver a iniciar sesión",
  "You can create trips for your corporate users or for third-party users":
    "Puedes crear viajes para tus usuarios corporativos o para usuarios terceros",
  Yes: "Sí",
  "You've selected an invalid hour, previous to current time. Please select a different hour":
    "Has seleccionado una hora inválida, anterior a la actual. Por favor seleccione una hora distinta",
  "Yes! When requesting a trip through the Corporate Panel, select ''Non-Corporate User'', fill in the fields, you proceed to request the trip and that's it, your rider will arrive right away.":
    "¡Sí! Al momento de solicitar un viaje por el Panel Corporativo, selecciona ''Usuario No Corporativo'', llenas los campos, procedes a pedir el viaje y listo, tu rider llegará enseguida.",
  "You can also make quick quotes":
    "También es posible realizar cotizaciones rápidas",
  Year: "Año",
  "you may search corporate users by:":
    "Puedes buscar usuarios de tu nómina por:",
  "You can create parcel for your corporate users or for third-party users":
    "Tus usuarios corporativos van a ser responsables del envío",
  yes: "Sí",

  // HEADERS
  "LAST STOP": "ÚLTIMA PARADA",
  "ÚLTIMA PARADA": "ÚLTIMA PARADA",

  STOPS: "PARADAS",
  PARADAS: "PARADAS",

  SERVICE: "SERVICIO",

  STOP: "PARADA",
  PARADA: "PARADA",

  "STOP COST": "COSTO DE PARADA",
  "COSTO DE PARADA": "COSTO DE PARADA",

  FEE: "RECARGO",
  RECARGO: "RECARGO",

  "TOTAL STOP": "TOTAL PARADA",
  "TOTAL PARADA": "TOTAL PARADA",

  "STOP QUANTITY": "CANTIDAD PARADAS",
  "CANTIDAD PARADAS": "CANTIDAD PARADAS",

  "ESTIMATED TIME": "TIEMPO ESTIMADO",
  "TIEMPO ESTIMADO": "TIEMPO ESTIMADO",

  "ESTIMATED DISTANCE": "DISTANCIA ESTIMADA",
  "DISTANCIA ESTIMADA": "DISTANCIA ESTIMADA",

  "MULSTISTOP COST": "COSTO MULTIPARADA",
  "COSTO MULTIPARADA": "COSTO MULTIPARADA",

  Add: "Agregar",
  Remove: "Eliminar",
  "Promo Code": "Cupón promocional",
  "Add Promo Code": "Agrega un cupón",
  "The promo code has expired or is invalid":
    "El código promocional ha expirado o es inválido",
  "Promo code applied successfully": "Código promocional aplicado con éxito",
  "Error getting estimated fare with promo code":
    "Error al obtener la tarifa estimada con el código promocional",

  "trip description": "Descripción del viaje",
  "TRIP DESCRIPTION": "DESCRIPCIÓN DEL VIAJE",
  "Add Description": "Agregar descripción",
  "Add trip description": "Añade una descripción al viaje",
  Completado: "Completado",
  "ID VIAJE": "ID VIAJE",
  DESCRIPTION: "DESCRIPCIÓN",

  "Exporting parcels": "Exportando envíos",
  "Exporting trips": "Exportando viajes",
  "You can download the export file":
    "Puedes descargar el archivo de exportación",
  expired: "expirado",
  "Processing pages for Excel file": "Procesando páginas para archivo Excel",
  "Processing page": "Procesando página",
  of: "de",
  "Sorry, there was an error": "Lo sentimos, hubo un error",
  Close: "Cerrar",
  "The export file has": "El archivo de exportación ha",
  Download: "Descargar",

  "Download PDF": "Descargar PDF",
  "Service Note": "Nota de servicio",
  "Download Quote": "Descargar Cotización",
  "Service Quote to": "Cotización de servicio para",
  "Service Quote": "Cotización de servicio",
  SURGE: "SOBREDEMANDA",
  TOTAL: "TOTAL",
  "Note: This quote represents a referential value of the trip. This is only a quote, if you want to schedule the trip contact your agent.":
    "Nota: Esta cotización representa un valor referencial del viaje. Esta es solo una cotización, si deseas programar el viaje contacta a tu agente.",
  "the value of the trip is subject to change":
    "el valor del viaje se encuentra sujeto a cambios",
  "PARADA FINAL": "PARADA FINAL",

  "Exporting payments": "Exportando pagos",
  "Pago móvil automatizado": "Pago móvil automatizado",
  "FACTURA PERSONALIZADA": "FACTURA PERSONALIZADA",
  MONEDA: "MONEDA",
  TIPO: "TIPO",
  "FECHA ENVIADO": "FECHA ENVIADO",
  "FECHA DE RECARGA": "FECHA DE RECARGA",

  Total: "Total",

  DESCRIPCIÓN: "DESCRIPCIÓN",
  "Cancel Reason": "Razón de cancelación",
  "Select one of the following reasons to cancel this trip":
    "Selecciona una de las siguientes razones para cancelar este viaje",
  Confirm: "Confirmar",

  "Enter current password": "Ingresa contraseña actual",
  "Enter new password": "Ingresa nueva contraseña",
  "Confirm new password": "Confirmar nueva contraseña",
  "Incorrect password": "Contraseña incorrecta",
  "Change password": "Cambiar contraseña",
  "Your password has been saved successfully":
    "Tu contraseña ha sido guardada con éxito",
  "Passwords do not match": "La contraseña no coincide",
  Continue: "Continuar",

  "Passwords must match": "Las contraseñas deben coincidir",
  "Recover password": "Recuperar contraseña",
  "To recover your password, enter your email":
    "Para recuperar tu contraseña indica el correo electrónico",
  GOBACK: "VOLVER",
  "with instructions":
    "con instrucciones para restablecer tu contraseña. Revisa tu bandeja de entrada, incluyendo la carpeta de spam",
  "Check your email": "Revisa tu correo",
  "Set the new password and its confirmation":
    "Establece la nueva contraseña y su confirmación",
  PasswordNewConfirm: "Confirmar nueva contraseña",
  "New Password": "Nueva contraseña",
  ResetPassword: "Restablecer contraseña",
  "The link has expired. Request a new link to reset your password":
    "El enlace ha expirado. Solicita un nuevo enlace para restablecer tu contraseña",
  "We're sorry!": "¡Lo sentimos!",
  "Back to the start": "Volver al inicio",
  "Error resetting password": "Error al restablecer la contraseña",
  "An error occurred, please try again later":
    "Ocurrió un error, intenta más tarde",
  "The email is not valid": "El correo no es válido",
  NOTE: "NOTA",
  ForgotPassword: "Olvidé mi contraseña",
  "Select payment method": "Seleccionar método de pago",
  Available: "Disponible",
  "Amount is required": "El monto es requerido",
  "Amount must be greater than 0": "El monto debe ser mayor a 0",
  "Amount to pay": "Monto a pagar",
  "Make the payment to": "Realiza el pago a",
  Bank: "Banco",
  "Bank copied!": "¡Banco copiado!",
  "RIF copied!": "¡RIF copiado!",
  "Phone number": "Número de teléfono",
  "Phone number copied!": "¡Número de teléfono copiado!",
  "Enter the details of the pago móvil made":
    "Ingresa los detalles del pago móvil realizado",
  "Payment date": "Fecha de pago",
  "Last 4 reference digits": "Últimos 4 dígitos de la referencia",
  "Amount to add": "Monto a agregar",
  Back: "Volver",
  "Text copied": "Texto copiado",
  "not found in Ridery's database":
    "Transferencia no encontrada en la base de datos de Ridery",
  "You can review the data of": "Revisa los datos ingresados y vuelve a intentarlo o solicita asistencia a tu ejecutivo de ventas",
  "and try again or request assistance":
    "y reintentar de nuevo o solicitar asistencia",
  "Request Assistance": "Solicitar Asistencia",
  "Review data": "Revisar datos",
  "Top up pending!": "¡Estamos procesando tu pago!",
  "Your manual top up has been sent to Ridery's database":
    "Tu pago manual ha sido enviado a la base de datos de Ridery",
  "Invoice status update banner emphasis":
    "El estatus de tus facturas se actualizará automáticamente",
  "Invoice status update banner detail": " una vez validemos tu pago",
  "Payment result partial banner emphasis":
    "El monto recibido es menor al monto total.",
  "Payment result partial banner detail":
    " Algunas facturas permanecerán con saldo pendiente o en estado de pago parcial.",
  "Payment result success banner emphasis": "¡Excelente!",
  "Payment result success banner detail":
    " Tus facturas fueron pagadas y su estatus se actualizó automáticamente.",
  "Top up successful!": "¡Recarga exitosa!",
  Added: "Se agregaron",
  "to your corporate balance of a pago móvil of Bs":
    "a tu balance corporativo de un pago móvil de Bs",
  "to your corporate balance from a payment":
    "a tu balance corporativo de un pago",
  "Corporate balance": "Balance corporativo",
  "Account holder": "Titular de la cuenta",
  "Account holder copied!": "¡Titular de la cuenta copiado!",
  "Email copied!": "¡Correo electrónico copiado!",
  "Memo number": "Número de memo",
  "Memo number copied!": "¡Número de memo copiado!",
  "Enter the details of the zelle made": "Coloca los datos del zelle realizado",
  "Enter your payment date": "Ingrese su Fecha de pago",
  "Amount sent": "Monto enviado",
  "The amount sent cannot exceed {max}.":
    "El monto enviado no puede superar {max}.",
  "Zelle owner": "Propietario zelle",
  "The zelle owner is the person or entity that made the payment":
    "El propietario zelle es la persona o entidad que realizó el pago",
  "Do you want a custom invoice?": "¿Desea factura personalizada?",
  "Is this top up related to a proform?":
    "¿Esta recarga corresponde a una proforma?",
  "Proforma number": "Número de Proforma",
  Proforma: "Proforma",
  "Make your payment using the following coordinates and instructions":
    "Realiza tu pago Utilizando las siguientes coordenadas e instrucciones",
  Reference: "Referencia",
  "Send your payment receipt and related information to process the transaction":
    "Envia tu comprobante de pago e información relacionada para procesar la transacción",
  "Email to send invoice": "Correo a enviar factura",
  "Payment receipt": "Comprobante de pago",
  Recharge: "Recargar",
  "BALANCE HISTORY": "HISTORIAL DE BALANCE",
  "MANUAL TOP UPS": "RECARGAS MANUALES",
  No: "No",
  "You've selected an invalid time. Please select a time that is at least 15 minutes from now.":
    "Has seleccionado una hora inválida. Por favor selecciona una hora que sea al menos 15 minutos desde ahora.",
  "You've selected an invalid time. Please create a new quote is at least 10 minutes from now.":
    "Has seleccionado una hora inválida. Por favor crea una nueva cotización que sea al menos 10 minutos desde ahora.",

  "The link has expired. Request a new link to reset enter in assist mode":
    "El enlace ha expirado. Solicita un nuevo enlace para entrar en modo asistido",
  "Welcome to": "Bienvenido a",
  "Use your admin credentials and access the panel":
    "Usa tus credenciales del admin y accede al panel",
  "Assist Mode": "Modo Asistido",

  "Exporting payroll": "Exportando nómina",
  "Esperando aprobación": "Esperando aprobación",
  Inactivo: "Inactivo",
  "How to start?": "¿Cómo empezar?",
  "Contact us": "Contáctanos",
  Benefits: "Beneficios",
  Solutions: "Soluciones",
  "All Ridery services, adapted to":
    "Todos los servicios de Ridery, adaptados a",
  "your business.": "tu empresa.",
  "The ecosystem of mobility, shipping and logistics in a single place":
    "El ecosistema de movilidad, logística y publicidad en un solo lugar",
  "Mobility and shipping": "Movilidad y envíos",
  "Shipping and logistics": "Envíos y encomiendas",
  "Manage and track your business deliveries in an automated way.":
    "Gestiona y rastrea las entregas de tu negocio de forma automatizada.",
  "Benefits for your collaborators": "Beneficios para tus colaboradores",
  "Show appreciation to your employees and customers with credits and coupons.":
    "Muestra apreciación a tus empleados y clientes con abonos y cupones.",
  "Logistics and heavy cargo": "Logística y carga pesada",
  "Logistics and heavy cargo.": "Logística y carga pesada.",
  "Request services for moves, distribution routes and more.":
    "Solicita servicios para mudanzas, rutas de distribución y más.",
  "Ridery360 is the comprehensive solution that helps you optimize your business needs in a flexible and efficient way.":
    "Ridery360 es la solución integral que te ayuda a optimizar de manera flexible y eficiente todas las necesidades de tu negocio en un solo lugar.",

  Welcome: "Bienvenido",
  Updated: "Actualizado",
  "See more": "Ver más",
  Shipments: "Envíos",
  "Trips this month": "Viajes este mes",
  "Shipments this month": "Envíos este mes",
  Collaborators: "Colaboradores",
  "View trip": "Ver viaje",
  "View shipment": "Ver envío",
  Forbidden: "Prohibido",
  Actives: "Activos",
  "Create shipment": "Crear envío",
  Summary: "Resumen",
  "In progress": "En curso",
  "No trips yet": "Aún no has realizado ningún viaje",
  "No shipments yet": "Aún no has realizado ningún envío",
  HELP: "AYUDA",
  Support: "Soporte",

  tooltipCredit:
    "Los adelantos corporativos, son un adelanto en tu balance para que puedas seguir realizando viajes en el panel, contacta a tu ejecutivo para mayor información",
  Credits: "Adelantos",
  "Billed amount": "Monto facturado",
  "PAY ADVANCE": "PAGAR ADELANTO",
  "PAY DEBT": "PAGAR DEUDA",
  day: "día",
  days: "días",
  Missing: "Faltan",
  Expired: "Vencido",
  Expires: "Vence",

  "Successful payment!": "¡Pago exitoso!",
  "Was credited": "Recibimos tu transferencia de",
  "to your credit of a pago móvil of Bs":
    "a tu adelanto de un pago móvil de Bs",
  "Credit balance": "Balance de adelanto",
  "Exporting corporate credits": "Exportando adelantos corporativos",
  "This is the amount credited to the account for the credit":
    "Este es el monto abonado a la cuenta por el adelanto",
  "AMOUNT ADVANCED": "MONTO ADELANTADO",
  "AMOUNT PAID": "MONTO PAGADO",
  "EXPIRATION DATE": "FECHA DE VENCIMIENTO",
  "Credit Detail": "Detalle de adelanto",
  "Advance data": "Datos del adelanto",
  "Approval date": "Fecha de aprobación",
  "Expiration date": "Fecha de vencimiento",
  "Amount added": "Monto adelanto",
  "Paid amount": "Monto pagado",

  Contáctanos: "Contáctanos",

  "Full name": "Nombre completo",
  "Company name or business name": "Nombre o razón social de la empresa",
  "Error verifying reCAPTCHA": "Error al verificar el reCAPTCHA",
  "Position in company": "Cargo en la empresa",
  Industry: "Industria",
  "Other (specify)": "Otro (especifique)",
  "Specify industry": "Especifique la industria",
  "Estimated number of employees": "Número de empleados estimados",
  City: "Ciudad",
  "Specify city": "Especifique la ciudad",
  "How can we help you?": "¿Cómo podemos ayudarte?",
  "Specify how we can help you": "Especifique cómo podemos ayudarle",
  "How did you hear about us?": "¿Cómo escuchaste de nosotros?",
  "Specify how you found us": "Especifique cómo nos conoció",
  Comments: "Comentarios",
  "Complete the form and a representative from our team will contact you.":
    "Completa el formulario y un representante de nuestro equipo se pondrá en contacto contigo.",
  "Error sending form": "Error al enviar el formulario",
  "validation.required": "Este campo es requerido",
  "validation.min": "El campo debe tener al menos {length} caracteres",
  "validation.numeric": "Solo se permiten números",
  "validation.phone": "El teléfono debe tener exactamente 10 dígitos",
  "validation.max": "El campo debe tener como máximo {length} caracteres",

  // Industries
  Distribuidores: "Distribuidores",
  Banca: "Banca",
  "Servicios Profesionales": "Servicios Profesionales",
  Transporte: "Transporte",
  Salud: "Salud",
  Tecnología: "Tecnología",
  "Fundación / ONG": "Fundación / ONG",
  Marketing: "Marketing",
  Servicios: "Servicios",
  Seguros: "Seguros",
  Otros: "Otros (especifique)",
  "Consumo masivo": "Consumo masivo",
  Retail: "Retail",

  // Employees
  "1 - 10": "1 - 10",
  "11 - 50": "11 - 50",
  "51 - 200": "51 - 200",
  "201 - 500": "201 - 500",
  "500+": "Más de 500",

  // Cities
  Caracas: "Caracas",
  Maracaibo: "Maracaibo",
  Valencia: "Valencia",
  Barquisimeto: "Barquisimeto",
  Maracay: "Maracay",
  "Puerto Ordaz": "Puerto Ordaz",
  "Guarenas-Guatire": "Guarenas-Guatire",
  "Altos Mirandinos": "Altos Mirandinos",
  "Barcelona / Puerto La Cruz / Lechería":
    "Barcelona / Puerto La Cruz / Lechería",

  // How can we help you
  "Business mobility: simplifies the transfers and shipments of your team in the city.":
    "Movilidad para negocios: simplifica los traslados y encomiendas de tu equipo en la ciudad.",
  "Article delivery: perform automated shipments and on demand for your clients.":
    "Entrega de artículos: realiza envíos automatizados y bajo demanda para tus clientes.",
  "Events and expenses: provides balance for travel or meals to your collaborators.":
    "Eventos y viáticos: proporciona saldo para viajes o comidas a tus colaboradores.",
  "Employee benefits: pays KMs or buys gift cards for your employees.":
    "Beneficios para empleados: abona KMs o compra tarjetas de regalo a tus colaboradores.",
  "Employee transportation: schedules buses for recurring routes.":
    "Transporte de colaboradores: programa autobuses para rutas recurrentes.",
  "Group travel: rent group transport vehicles for specific events or transfers.":
    "Viajes grupales: alquila vehículos de transporte grupal para eventos o traslados específicos.",
  "Smart logistics: manages freight, moves, transport and cargo logistics for your business.":
    "Logística inteligente: gestiona fletes, mudanzas, transporte y logística de carga para tu negocio.",
  "Support: personalized 24/7 support to manage your, shipments and logistics.":
    "Soporte: atención personalizada 24/7 para gestionar tus viajes, envíos y logística.",

  // How did you find us
  Event: "Evento",
  Advertising: "Publicidad",
  "Referred by a known": "Referido por conocido",
  "Social media": "Redes sociales",

  "Additional comments": "Comentarios adicionales",
  "Completa el formulario y en breve te contactaremos para aclarar tus dudas.":
    "Completa el formulario y en breve te contactaremos para aclarar tus dudas.",
  "¿Tienes preguntas sobre": "¿Tienes preguntas sobre",
  "Ridery 360": "Ridery 360",
  RIF: "RIF",
  "Credit data": "Datos del adelanto",
  "Credit movements": "Movimientos de adelanto",
  corporate_credit_added: "Adelanto abonado",
  corporate_credit_reverted: "Adelanto revertido",
  corporate_credit_payment: "Pago de adelanto",
  "Movimientos del adelanto": "Movimientos del adelanto",
  Refresh: "Actualizar",
  "See payroll": "Ver nómina",
  "Associated panels": "Paneles asociados",
  NoDataAssociatedPanels: "No hay paneles asociados activos",
  "Associated Panel": "Panel asociado",
  amountRecharge: "Monto recargado",
  "Make shipments and transfers with certified vehicles.":
    "Haz envíos y traslados con vehículos certificados.",
  "Drivers with verified access and secure processes":
    "Conductores con acceso verificado y procesos seguros",
  "Automate your business deliveries with API integration.":
    "Automatiza las entregas de tu negocio con integración vía API.",
  "Promote your brand while you move": "Promociona tu marca mientras te mueves",
  "Operational efficiency for your business":
    "Eficiencia operativa para tu empresa",
  "Request or schedule comfortable and safe transfers with verified drivers.":
    "Solicita o programa viajes y envíos de forma cómoda y segura",
  "The integral solution that moves your business.":
    "La solución integral que mueve a tu empresa.",
  "Discover how companies maximize the panel to optimize their processes.":
    "Descubre cómo las empresas aprovechan al máximo el panel para optimizar sus procesos.",
  Services: "Servicios",

  // Landing Page Translations
  "Transform your company's mobility": "Transforma la movilidad de tu empresa",
  "Move your company quickly, comfortably and safely, at the best price in the market.":
    "Mueve a tu empresa de manera rápida, cómoda y segura, al mejor precio del mercado.",
  "Start today": "Comienza hoy",
  Our: "Nuestro",
  "corporate panel": "panel corporativo",
  "Manage your company's transfers at any time":
    "Gestiona los traslados de tu empresa en cualquier momento",
  "Create or schedule trips instantly, monitor your business shipments and check the status of your budget using your business account":
    "Crea o programa viajes al instante, monitorea los envíos de tu negocio y comprueba el estatus de tu presupuesto usando tu cuenta para empresas",
  "Manage your budget in real time": "Administra tu presupuesto en tiempo real",
  "Create invoices and account statements in seconds to keep track of your mobility expenses effortlessly":
    "Crea facturas y estados de cuenta en segundos para llevar el control de tus gastos de movilidad sin esfuerzo alguno",
  "Affiliate your entire company with a few clicks":
    "Afilia a toda tu empresa con pocos clics",
  "Add specific people or your entire organization with bulk payroll upload and assign available balances in a personalized way":
    "Agrega personas específicas o a toda tu organización con la carga masiva de nómina y asigna saldos disponibles de forma personalizada",
  "Make trips or shipments with multiple destinations":
    "Realiza viajes o envíos con múltiples destinos",
  "Move your team to different points in the city or send important packages to multiple destinations in the same trip with more economical rates.":
    "Traslada a tu equipo a diferentes puntos de la ciudad o envía paquetes importantes a varios destinos en un mismo viaje con tarifas más económicas.",
  "What is Ridery 360?": "¿Qué es Ridery 360?",
  "It is a comprehensive solution for companies that combines mobility, logistics, advertising and services oriented to the welfare of employees, centralized in a platform designed to facilitate management, optimize operations and enhance the growth of businesses of any size at the national level.":
    "Es una solución integral para empresas que combina movilidad, logística, publicidad y servicios orientados al bienestar de los colaboradores, centralizada en una plataforma diseñada para facilitar la gestión, optimizar operaciones y potenciar el crecimiento de negocios de cualquier tamaño a nivel nacional.",
  "How to start using Ridery 360?": "¿Cómo empezar a usar Ridery 360?",
  "Once your 360 panel is activated, you can start using Ridery 360 by recharging balance through a prepaid modality. That balance is used to cover trips, shipments or other services within the platform. There are no mandatory subscriptions or individual charges.":
    "Una vez activado tu panel 360, puedes comenzar a utilizar Ridery 360 recargando saldo a través de una modalidad prepago. Ese balance se utiliza para cubrir viajes, envíos u otros servicios dentro de la plataforma. No hay suscripciones obligatorias ni cobros individuales.",
  "What level of security does Ridery 360 offer for corporate transfers and shipments?":
    "¿Qué nivel de seguridad ofrece Ridery 360 para los traslados y envíos corporativos?",
  "Ridery has 100% certified drivers and vehicles. From the panel, companies can monitor each transfer in real time, guaranteeing traceability, security and operational control.":
    "Ridery cuenta con conductores y vehículos 100 % certificados. Desde el panel, las empresas pueden monitorear en tiempo real cada traslado, garantizando trazabilidad, seguridad y control operativo.",
  "What other services are part of Ridery 360?":
    "¿Qué otros servicios forman parte de Ridery 360?",
  "In addition to trips and shipments, Ridery 360 includes access to services such as advertising in our spaces, API integration for automated deliveries, and synergies with allied companies such as Flety (transport and cargo logistics) and Busi (group mobility). Everything is managed from the same panel, providing a unified experience within the ecosystem.":
    "Además de viajes y envíos, Ridery 360 incluye acceso a servicios como publicidad (Advertising) en nuestros espacios, integración vía API para entregas automatizadas, y sinergias con empresas aliadas como Flety (transporte y logística de carga) y Busi (movilidad grupal). Todo se gestiona desde un mismo panel, brindando una experiencia unificada dentro del ecosistema.",
  "What benefits does using Ridery 360 have compared to the Ridery app?":
    "¿Qué beneficios tiene usar Ridery 360 en comparación con la app de Ridery?",
  "With Ridery 360, companies access tax invoicing, personalized 24/7 attention, budget control per user and real-time visibility of each trip or shipment. In addition, the panel is integrated with the Ridery app, which allows collaborators to have a self-manageable experience.":
    "Con Ridery 360, las empresas acceden a facturación fiscal, atención personalizada 24/7, control de presupuesto por usuario y visibilidad en tiempo real de cada viaje o envío. Además, el panel está integrado con la app de Ridery, lo que permite a los colaboradores tener una experiencia autogestionable.",
  "Join the": "Únete a las",
  "companies that trust us": "empresas que confían en nosotros",
  "Start now without initial costs": "Tu equipo se mueve. Tú tienes el control.",
  "No previous recharges": "Sin recargas previas: Activa tu cuenta, define límites de gastos, revisa cada consumo y gestiona tu facturación desde un solo lugar.",
  "Register and set up your account": "Activa tu cuenta",
  "Guarantee smooth expense management without paying additional service fees.":
    "Comienza a operar con tu límite de crédito acordado y sin tarifas de activación.",
  "Add your collaborators": "Tu equipo opera",
  "Assign balance for trips or shipments and personalized spending limits.":
    "Asigna a cada colaborador un límite de gasto o sobregiro para viajes y envíos.",
  "Manage your logistics with Ridery 24/7":
    "Gestiona tu facturación",
  "Manage mobility, deliveries, logistics and benefits of your business in one place.":
    "Recibe tus consumos consolidados, gestiona tus pagos y lleva el control de retenciones desde un solo lugar.",
  "Reduce your transport, shipping and logistics costs":
    "Reduce tus costos de transporte, envíos y logística",
  "up to 35%": "hasta en un 35%",
  "with Ridery": "con Ridery",
  "Talk to us": "Habla con nosotros",

  // ProspectModal translations
  "Welcome to Ridery's Corporate Panel":
    "Bienvenido al Panel Corporativo de Ridery",
  "For us it is a pleasure to be your best mobility ally and take care of the comfort of your executives, ensuring that they will be there when you need them and that they will receive the most exclusive and safe transfer in Venezuela.":
    "Para nosotros es un placer ser tu mejor aliado de movilidad y encargarnos de la comodidad de tus ejecutivos asegurando que estarán ahí cuando los necesites y que recibirán el traslado más exclusivo y seguro de Venezuela.",
  "In order to help you, we need you to provide us with the following information so that our team can communicate with you.":
    "Para poder ayudarte, necesitamos que nos proveas la siguiente información para que nuestro equipo se comunique.",
  "Basic contact information": "Datos básicos de contacto",
  "Business name": "Razón social de la empresa",
  "Contact phone": "Teléfono de contacto",
  "Rif type": "Tipo de rif",
  "Rif number": "Número de rif",
  Position: "Posición",
  Next: "Siguiente",
  "Tell us about your business": "Cuéntanos sobre tu empresa",
  "What is the size of the company in number of employees?":
    "¿Cuál es el tamaño de la empresa en número de empleados?",
  "How many trips do you think your company would need on average per week?":
    "¿Cuántos traslados cree que su empresa necesitaría en promedio a la semana?",
  "In which city is the population of employees you want to mobilize?":
    "¿En qué ciudad se encuentra la población de empleados que deseas movilizar?",
  "Other (input)": "Otro (indique)",
  "We would like to know a little about your specific need in order to serve you better. Please, explain to us what you expect from our corporate service":
    "Nos gustaría conocer un poco de su necesidad específica para servirle mejor. Por favor, explíquenos qué espera de nuestro servicio corporativo",
  "Sending Form": "Enviando formulario",
  "Thanks for your interest": "Gracias por tu interés",
  "Our sales team will contact you":
    "Nuestro equipo de ventas se pondrá en contacto contigo",
  "There has been a problem": "Ha ocurrido un problema",
  "You can go back and retry": "Puedes regresar y reintentar",
  "Go back to the start": "Volver al inicio",

  // Testimonials
  "The platform has been key in optimizing our operations. It is intuitive, easy to use and gives us excellent information control. The team's attention has been impeccable, always willing to support us. Undoubtedly, a tool that has contributed to our growth.":
    "La plataforma ha sido clave en optimizar nuestras operaciones. Es intuitiva, fácil de usar y nos brinda un excelente control de la información. La atención del equipo ha sido impecable, siempre dispuestos a apoyarnos. Sin duda, una herramienta que ha contribuido a nuestro crecimiento.",
  "We value the efficiency and flexibility that Ridery has brought to our corporate mobility. The platform is intuitive and the transfers are safe and punctual. It has optimized our times and has directly contributed to the productivity of our teams. A service we recommend.":
    "Valoramos la eficiencia y flexibilidad que Ridery ha aportado a nuestra movilidad corporativa. La plataforma es intuitiva y los traslados son seguros y puntuales. Ha optimizado nuestros tiempos y ha contribuido directamente a la productividad de nuestros equipos. Un servicio que recomendamos.",
  "Ridery's service and attention have been excellent. From the beginning we have received constant support. We value their focus on innovation and building long-term relationships with their clients.":
    "El servicio y la atención de Ridery han sido excelentes. Desde el inicio hemos recibido un acompañamiento constante. Valoramos su enfoque en la innovación y en construir relaciones de largo plazo con sus clientes.",
  "We are very satisfied with Ridery's service. The platform is practical, the vehicles and drivers meet the standards we are looking for, and the team's attention is first-class. It is a service we highly recommend.":
    "Estamos muy satisfechos con el servicio de Ridery. La plataforma es práctica, los vehículos y conductores cumplen con los estándares que buscamos, y la atención del equipo es de primera. Es un servicio que recomendamos ampliamente.",
  "Ridery's service is one of our first options for national transfers. The platform is easy and friendly both for our collaborators and for the company. It facilitates the management and assignment of trips, and we hope to continue strengthening this alliance.":
    "El servicio de Ridery es una de nuestras primeras opciones para traslados a nivel nacional. La plataforma es fácil y amigable tanto para nuestros colaboradores como para la empresa. Nos facilita la gestión y asignación de viajes, y esperamos seguir fortaleciendo esta alianza.",
  "Mobility and transport": "Movilidad y transporte",
  "Integrated shipments": "Envíos integrados",
  "Promote your brand in advertising spaces in the Ridery app or mobile screens in our vehicles.":
    "Impulsa tu marca a través de espacios Advertising en la app de Ridery o en las pantallas móviles de nuestros vehículos.",
  "your business.2": "tu empresa",
  Explore: "Explora",
  "Enjoy the benefits of the ecosystem":
    "Disfruta los beneficios del ecosistema",

  "100% certified drivers and vehicles":
    "Conductores y vehículos 100% certificados",
  "For the safety of your collaborators, all drivers go through a rigorous certification process:":
    "Por la seguridad de tus colaboradores, todos los conductores pasan por un riguroso proceso de certificación:",
  "Comprehensive psychotechnical evaluation.":
    "Evaluación psicotécnica integral.",
  "Mechanical and aesthetic review of the vehicle.":
    "Revisión mecánica y estética del vehículo.",
  "Verification of up-to-date legal documents.":
    "Verificación de documentos legales al día.",

  "24/7 personalized support channel": "Canal de atención personalizada 24/7",
  "To guarantee an optimal experience, we provide accompaniment and comprehensive support at all times:":
    "Para garantizar una experiencia óptima, ofrecemos acompañamiento y soporte integral en todo momento:",
  "Immediate support for any incident or requirement.":
    "Soporte inmediato ante cualquier incidencia o requerimiento.",
  "Assignment of a dedicated executive for inquiries and follow-up.":
    "Asignación de un ejecutivo dedicado para consultas y seguimiento.",
  "Real-time monitoring of trips and shipments.":
    "Monitoreo en tiempo real de viajes y envíos.",

  "Full access to all our services": "Acceso total a todos nuestros servicios",
  "From mobility and logistics to advertising and employee well-being, the entire Ridery ecosystem is at your disposal:":
    "Desde movilidad y logística hasta publicidad y bienestar para colaboradores, todo el ecosistema Ridery está a tu disposición:",
  "Centralized billing management.": "Gestión centralizada de facturación.",
  "Hiring advertising spaces to boost your brand.":
    "Contratación de espacios publicitarios para impulsar tu marca.",
  "API integration to automate your logistics processes.":
    "Integración vía API para automatizar tus procesos logísticos.",

  "Frequently Asked Questions": "Preguntas Frecuentes",
  "If you have any questions, here are some answers that may help you. If you need personalized support, don't hesitate to contact us.":
    "¿Tienes alguna duda? Aquí tienes algunas respuestas que podrían ayudarte. Si necesitas soporte personalizado, no dudes en contactarnos.",
  "Go back": "Atrás",
  "Error loading cities. Please try again later.":
    "Error al cargar las ciudades. Por favor, inténtalo de nuevo más tarde.",

  "No data": "No hay datos",
  "Create new trip": "Crear nuevo viaje",
  Schedule: "Programados",
  Recents: "Recientes",
  Driver: "Conductor",
  Map: "Mapa",
  "Add description": "Agregar descripción",
  "Copy trip link": "Copiar enlace del viaje",
  "Copy shipment link": "Copiar enlace del envío",
  Username: "Nombre de usuario",
  in_progress: "En progreso",
  Completeds: "Completados",
  Schedules: "Programados",
  Cancelleds: "Cancelados",
  Filters: "Filtros",
  "Create new parcel": "Crear nuevo envío",
  "No se encontraron resultados": "No se encontraron resultados",
  "No results found": "No se encontraron resultados",
  "Service note": "Nota de servicio",
  "Cancelled by provider": "Cancelado por el conductor",
  "cargo_logistics": "Logística de carga",
  "cargoLogistics": "Logística de carga",
  "quote_your_cargo_title": "Cotiza tu traslado de carga con Ridery",
  "quote_your_cargo_subtitle": "Planifica y cotiza el transporte de tu carga de forma rápida y segura",
  "cargo_logistics_origin_destination": "Indica el origen y destino del envío",
  "cargo_origin_label": "Dirección de origen",
  "cargo_origin_placeholder": "Ej. Galpón Industrial Los Ruices, Caracas",
  "cargo_destination_label": "Dirección de destino",
  "cargo_destination_placeholder": "Ej. Centro Empresarial La Trinidad, Caracas",
  "cargo_pick_your_truck": "Elige el camión adecuado para tu carga",
  "cargo_truck_type_label": "Tipo de camión",
  "cargo_truck_type_placeholder": "Selecciona tipo",
  "cargo_truck_model_label": "Modelo de camión",
  "cargo_truck_model_placeholder": "Selecciona modelo",
  "cargo_truck_capacity_label": "Capacidad de carga",
  "cargo_truck_capacity_placeholder": "Selecciona capacidad",
  "cargo_service_type_label": "Tipo de servicio",
  "cargo_service_type_placeholder": "Selecciona tipo de servicio",
  "cargo_assistant_label": "Número de ayudantes",
  "cargo_assistant_placeholder": "Selecciona número de ayudantes",
  "cargo_service_details": "Agrega los detalles del servicio",
  "cargo_generate_quote_with_registered_data": "Generar cotización con datos registrados",
  "cargo_enterprise_name_label": "Nombre de la empresa",
  "cargo_enterprise_email_label": "Correo electrónico",
  "cargo_enterprise_phone_label": "Número de teléfono",
  "cargo_add_company_information": "Ingresa la información de la persona que gestionará la cotización",
  "cargo_find_truck_long": "¿No sabes qué camión elegir? Encuéntralo aquí",
  "cargo_find_truck_short": "¿No sabes qué camión elegir?",
  "cargo_request_quote_button": "Solicitar cotización",
  "cargo_service_options_title": "Responde unas breves preguntas para recomendarte el camión ideal para tu carga.",
  "cargo_service_transportation_way": "¿Cómo viene tu carga?",
  "cargo_service_options_service_type": "¿Qué tipo de servicio necesitas?",
  "cargo_service_options_box": "En cajas",
  "cargo_service_options_pallets": "En paletas",
  "cargo_service_options_loose": "En granel (suelto)",
  "cargo_service_options_moveout": "Mudanza",
  "cargo_service_options_transport": "Traslado de muebles o productos nuevos",
  "cargo_service_options_separator": "O bien",
  "box_calculate_by_title": "¿Cómo quieres calcular tu carga?",
  "box_calculate_by_box_volume": "Por volumen",
  "box_calculate_by_box_weight": "Por peso",
  "dimentions_title": "Ingresa las medidas de tus cajas",
  "dimentions_subtitle": "Usa las medidas externas de cada caja para calcular el espacio total.",
  "weight_title": "Ingresa el peso total de tus cajas",
  "weight_subtitle": "Si conoces el peso por caja, suma el total estimado.",
  "weight_label": "Peso total (kg)",
  "weight_placeholder": "",
  "dimentions_height_label": "Alto (cm)",
  "dimentions_height_placeholder": "",
  "dimentions_width_label": "Ancho (cm)",
  "dimentions_width_placeholder": "",
  "dimentions_length_label": "Largo (cm)",
  "dimentions_length_placeholder": "",
  "dimentions_boxes_label": "Número de cajas",
  "dimentions_boxes_placeholder": "",
  "dimentions_total_label": "Metros cúbicos calculados: ",
  "ideal_truck_title": "Según tu carga, esta es la opción ideal",
  "ideal_truck_title_moveout": "Para mudanzas, este es la opción ideal",
  "ideal_truck_subtitle": "Puedes continuar para ver los detalles y cotizar tu traslado.",
  "ideal_truck_subtitle_moveout": "Te sugerimos incluir 4 ayudantes para la carga.",
  "pallets_title": "¿Cuántas paletas necesitas transportar?",
  "pallets_subtitle": "Elige el rango que más se acerque a tu carga.",
  "pallets_option_1": "1 paleta",
  "pallets_option_2_4": "2 - 4",
  "pallets_option_5_6": "5 - 6",
  "pallets_option_7_10": "7 - 10",
  "pallets_option_11_12": "11 - 12",
  "pallets_option_13_14": "13 - 14",
  "pallets_option_15_24": "15 - 24",
  "loose_title": "¿Qué tipo de carga vas a mover?",
  "loose_subtitle": "Elige la opción que mejor describa tu carga.",
  "loose_option_trash": "Basura o escombros",
  "loose_option_sand": "Arena",
  "loose_option_pipes": "Tubos o cabillas",
  "transport_title": "¿Qué tipo de artículos vas a trasladar?",
  "transport_subtitle": "Elige la opción que mejor describa lo que necesitas mover.",
  "transport_option_appliances": "Neveras / Lavadoras",
  "transport_option_furniture": "Muebles pequeños",
  "material_dimentions_title": "Indica las medidas de tu material",
  "material_dimentions_subtitle": "Ingresa el largo y el peso total para calcular el camión más adecuado.",
  "material_dimentions_length_label": "Largo (m)",
  "material_dimentions_length_placeholder": "",
  "material_dimentions_weight_label": "Peso total (kg)",
  "material_dimentions_weight_placeholder": "",
  "cargo_quote_request_sent": "Cotización exitosa",
  "cargo_quote_request_body": "El costo estimado de tu servicio es ",
  "cargo_quote_request_body_2": "Consulta el archivo PDF descargado o el correo que te enviamos para ver más detalles del servicio.",
  "cargo_quote_support_time": "Horario de atención:\nLunes a Viernes, de 9:00 AM a 5:00 PM",
  "cargo_service": "Servicio",
  "cargo_origin_address": "Dirección de origen",
  "cargo_destination_address": "Dirección de destino",
  "cargo_estimated_time": "Tiempo estimado",
  "cargo_cancellation_fee": "Tarifa de cancelación",
  "cargo_invoice_team": "Equipo de Ridery Corporativo",
  "cargo_invoice_thanks": "Gracias por preferirnos",
  "cargo_invoice_reference_note": "Nota: Esta cotización representa un valor referencial del viaje",
  "cargo_invoice_reference_note_2": "*el valor del viaje está sujeto a cambios",
  "cargo_invoice_service": "Cotización de servicio de carga",
  "cargo_invoice_service_quote": "Cotización de servicio",
  "cargo_invoice_date": "Fecha de emisión",
  "cargo_invoice_service_for": "Cotización de servicio para",
  "cargo_error_initializing_form": "Error al inicializar el formulario, intente más tarde",
  "cargo_origin_error": "Error al obtener la dirección de origen, intente más tarde",
  "cargo_destination_error": "Error al obtener la dirección de destino, intente más tarde",
  "cargo_quote_error": "Error al solicitar la cotización, intente más tarde",
  "cargo_addresses_require_map_selection": "Selecciona origen y destino entre las sugerencias de dirección para ubicar ambos puntos en el mapa.",
  "cargo_create_quote_error": "Error al crear la cotización, intente más tarde",
  "cargo_find_your_truck": "Encuentra el camión adecuado",
  "find_your_truck_next_step": "Siguiente",
  "find_your_truck_previous_step": "Regresar",
  "find_your_truck_restart": "Reiniciar",
  "find_your_truck_end": "Finalizar",
  "ideal_truck_error": "Error al obtener el camión ideal, intente más tarde",
  "contact_us_modal_title": "No pudimos cargar el servicio",
  "contact_us_modal_content": "Por favor, intenta de nuevo en unos minutos o contacta a tu ejecutivo para ayudarte con la solicitud.",
  "contact_us_modal_go_home": "Volver a Principal",
  "contact_us_modal_send_message": "Contactar Ejecutivo",
  "validation.alpha_special": "El campo {fieldName} solo permite letras, números, espacios y los caracteres: . - _ @ ,",
  "contact_us_modal_message": "Hola 👋\nTuve un inconveniente al cargar el servicio de *Flety* en *Ridery 360*.\n\nMe gustaría que me ayudes a *cotizar el servicio y continuar con la solicitud* desde aquí.\nQuedo atento(a), ¡gracias!",
  "ideal_truck_contact_us_modal_message": "Hola 👋\nTuve un inconveniente al encontrar un camión ideal para mi carga en *Flety* en *Ridery 360*.\n\nMe gustaría que me ayudes a *cotizar el servicio y continuar con la solicitud* desde aquí.\nQuedo atento(a), ¡gracias!",
  "ideal_truck_no_trucks": "No pudimos encontrar un camión ideal para tu carga. Por favor, contacta a tu ejecutivo para ayudarte con la solicitud.",

  // Rentals
  Rentals: "Rentals",
  Origin: "Origen",
  "Fleet type": "Tipo de flota",
  "Quote your Trip": "Cotiza tu viaje",
  "Enter your trip details to get a personalized quote":
    "Ingresa los detalles de tu viaje para obtener una cotización ajustada a tu medida",
  "Enter your pickup location": "Indica tu punto de origen",
  "Enter your service's pickup location":
    "Ingresa la dirección donde quieres que comience tu servicio.",
  "Pickup Location": "Dirección de origen",
  "Select the date and time of your trip":
    "Selecciona la fecha y hora del viaje",
  remember_time_notice: "Recuerda solicitar tu viaje con un",
  rental_time_notice:
    "mínimo de {hours} horas de anticipación y hasta {days} días a partir de hoy.",
  minimum_time_notice:
    "La fecha y hora del viaje debe ser al menos {hours} horas desde ahora",
  "Trip date": "Fecha del viaje",
  "DD/MM/YYYY": "DD/MM/AAAA",
  "Trip time": "Hora del viaje",
  "How long do you need it for?": "¿Por cuánto tiempo lo necesitas?",
  "Select the number of hours you need for your service":
    "Selecciona la cantidad de horas que requieres para tu servicio",
  "Select number of hours": "Selecciona la cantidad de horas",
  rental_outside_operational_area:
    "Esta dirección se encuentra fuera del área operativa de Ridery",
  "Trip details": "Detalles del viaje",
  "Enter the details and select the fleet that best suits your needs":
    "Ingresa los detalles y selecciona la flota que más se adapte a tus necesidades",
  "Reason for your trip": "Motivo de tu viaje",
  "Reason for your trip (Optional)": "Motivo de tu viaje (Opcional)",
  "Select a reason for your trip":
    "Selecciona algún motivo que describa tu viaje",
  "Trip details (Optional)": "Detalles de tu viaje (Opcional)",
  "Enter some details about your trip": "Escribe algunos detalles del viaje",
  "Select a fleet": "Elige la flota",
  "Select the best fleet for your trip from our options":
    "Elige entre nuestras opciones de flotas la que mejor se ajusta a tu viaje",
  Passengers: "pasajeros",
  Suitcase: "maleta",
  "This fleet is not available for the selected number of hours":
    "Esta flota no se encuentra disponible para la cantidad de horas seleccionadas",
  "No fleets available for the selected hours":
    "No hay flotas disponibles para las horas seleccionadas",
  "Error loading trip reasons": "Error al cargar motivos de viaje",
  "Error loading fleets": "Error al cargar flotas",
  "Select fleet type coming soon": "Selección de tipo de flota próximamente",
  "This step is under development": "Este paso está en desarrollo",
  "Review and confirm your rental quote":
    "Revisa y confirma tu cotización de alquiler",
  "Quote created successfully": "Cotización creada exitosamente",
  "Esta dirección se encuentra fuera del área operativa de Ridery.":
    "Esta dirección se encuentra fuera del área operativa de Ridery.",
  "This service is not available in the selected location":
    "Este servicio no está disponible en la ubicación seleccionada",
  Other: "Otro",
  Hours: "Horas",
  Resume: "Resumen",
  Fleet: "Flota",
  "Enter the details of your trip": "Ingresa los detalles de tu viaje",
  "Enter some details about your trip (optional)":
    "Escribe algunos detalles del viaje (opcional)",
  Duration: "Duración",
  "Trip description": "Descripción del viaje",
  "Create quote": "Crear cotización",
  "No description available": "No hay descripción disponible",
  "When you create a rental, you agree to our":
    "Al cotizar un rental, aceptas ",
  "Terms and conditions": "Términos y condiciones",
  "Privacy policies": "Políticas de privacidad",
  "and the": "y las",
  "Download quote": "Descargar cotización",
  "QUOTE ID": "ID cotización",
  "TRIP REASON": "MOTIVO DEL VIAJE",
  "TRIP DETAILS": "DETALLE DEL VIAJE",
  "Cotización de servicio": "Cotización de servicio",
  "Ready!": "¡Listo!",
  "Your quote is ready. If you want more information or prefer to confirm your trip, contact one of our agents.":
    "Tu cotización está lista. Si quieres más información o prefieres concretar tu viaje, comunícate con uno de nuestros agentes.",
  "This is only a quotation. Shortly, a Ridery agent will contact you to help you finalize your Rentals trip.":
    "Esta es solo una cotización. En breve, un agente de Ridery se pondrá en contacto contigo para ayudarte a concretar tu viaje de Rentals.",
  Important: "Importante",
  "This service applies exclusively to transfers within the same city":
    "Este servicio aplica exclusivamente para traslados dentro de una misma ciudad",
  "pay_corporate_bill": "Pagar facturas",
  "dont_show_message_again": "No volver a mostrar mensaje",
  "InvoicesToPay": "Facturas a pagar",
  "invoices_to_pay_title": "Selecciona las facturas a pagar",
  "invoices_to_pay_subtitle": "Selecciona una o varias facturas para pagarlas en un solo movimiento. Si tienes facturas vencidas, debes incluirlas obligatoriamente. En el siguiente paso podrás gestionar las retenciones.",
  "view_invoices": "Ver facturas",
  "available_credit": "Crédito disponible",
  "credit_used": "Usado",
  "available_amount": "Monto disponible",
  "available_credit_limit_tooltip": "Límite establecido junto a tu ejecutivo de ventas. Para modificarlo, comunícate con la persona responsable.",
  "wallet_available_amount": "Saldo disponible",
  "wallet_available_amount_tooltip": "Saldo disponible en tu billetera corporativa.",
  "billing_status": "Estado de facturación",
  "billing_status_info_tooltip":
    "Resumen de montos de facturas corporativas próximas, vigentes y vencidas.",
  "billing_status_upcoming": "Próximas",
  "billing_status_current": "Vigentes",
  "billing_status_overdue": "Vencidas",
  "billing_footer_upcoming": "Faltan {days} días",
  "billing_footer_expires": "Vence en {days} días",
  "billing_footer_overdue": "Venció hace {days} días",
  "billing_one_invoice": "1 factura",
  "billing_n_invoices": "{n} facturas",
  "corporate_invoices_history": "Historial de facturas",
  "bill_invoice_of_prefix": "Factura de",
  "bill_invoice_all_panels": "todos los paneles",
  "invoice_number": "Número de factura",
  "bill_status_all": "Todas",
  "bill_status_pending_payment": "Por pagar",
  "bill_status_processing_payment": "Procesando Pago",
  "bill_status_partial_payment": "Pago Parcial",
  "bill_status_paid": "Pagado",
  "bill_status_cancelled": "Cancelada",
  "bill_status_reversed": "Anulada",
  "bill_status_annulled": "Anulada",
  "bill_status_overdue_plural": "Vencidas",
  "bill_status_overdue": "Vencida",
  "bill_status_applied_credit_note": "Aplicada",
  "bill_status_processing_credit_note": "Procesando",
  "bill_document_no": "N° Documento",
  "bill_associated_panel": "Panel asociado",
  "bill_type": "Tipo",
  "bill_period": "Periodo",
  "bill_period_to": "al",
  "bill_issue_date": "Emisión",
  "bill_due_date": "Vencimiento",
  "bill_service_type": "Tipo de servicio",
  "bill_amount": "Monto",
  "bill_amount_due": "Por pagar",
  "bill_tooltip_amount_in_bs": "Monto en",
  "bill_tooltip_bcv_rate": "Tasa BCV",
  "bill_status": "Estado",
  "bill_doc_type_invoice": "FA",
  "bill_doc_type_credit_note": "NC",
  "bill_service_type_transportation": "Servicio de transporte",
  "bill_service_type_third_party": "Cuenta de terceros",
  "bill_payments_retentions_modal_title":
    "Pagos y retenciones | Factura #{number}",
  "bill_payment_details_total_amount": "Monto total",
  "bill_payment_details_includes_retentions": "Incluye retenciones",
  "bill_payment_details_total_applied": "Total aplicado",
  "bill_payment_details_pending": "Pendiente",
  "bill_payment_in_review_hint": "en revisión",
  "bill_payment_in_review_tooltip":
    'Este monto corresponde a pagos con estatus "En revisión"',
  "bill_payment_pay": "Pagar",
  "bill_payment_breakdown_title": "Desglose de pagos",
  "bill_retentions_title": "Retenciones",
  "bill_payment_col_id": "ID del pago",
  "bill_payment_col_method": "Método de pago",
  "bill_payment_col_amount": "Monto aplicado",
  "bill_payment_col_status": "Estatus de pago",
  "bill_payment_auto": "Automático",
  "bill_payment_manual": "Manual",
  "bill_retention_col_id": "ID de retención",
  "bill_retention_col_type": "Tipo",
  "bill_retention_col_date": "Fecha",
  "bill_retention_col_percent": "Porcentaje",
  "bill_retention_col_amount": "Monto",
  "bill_retention_col_status": "Estatus",
  "bill_view": "Ver",
  "bill_payment_status_review": "En revisión",
  "bill_payment_status_rejected": "Rechazado",
  "bill_payment_status_confirmed": "Confirmado",
  "bill_payment_status_applied": "Aplicada",
  "bill_payment_status_saved": "Creado",
  "bill_payment_status_skipped": "Revisión",
  "bill_retention_status_not_requested": "No solicitado",
  "bill_retention_status_pending": "Pendiente",
  "bill_retention_status_approved": "Aprobado",
  "bill_retention_status_refused": "Rechazado",
  "bill_retention_status_cancel": "Cancelado",
  "bill_payment_error_loading_invoice_details":
    "No se pudo cargar la factura, intente mas tarde",
  "date_from": "Desde",
  "date_to": "Hasta",
  "date_range": "Rango de fechas",
  "bill_invoice_type": "Tipo de factura",
  "bill_invoice_type_automatic": "Automática",
  "bill_invoice_type_cancellation": "Cancelación",
  "bill_actions": "Acciones",
  "bill_discard_invoice": "Descartar factura",
  "bill_discard_invoice_confirm_title": "¿Descartar esta factura?",
  "bill_discard_invoice_confirm_detail":
    "Se quitará de esta lista. Continúa solo si deseas descartarla.",
  "bill_invoice_selected_singular": "factura seleccionada",
  "bill_invoice_selected_plural": "facturas seleccionadas",
  "bill_continue_to_retentions": "Continuar a retenciones",
  "bill_billing_mismatch_title":
    "No pudimos agrupar estas facturas en un solo pago.",
  "bill_billing_mismatch_body":
    "Las facturas que seleccionaste corresponden a {childPanels} con {billingData} distintos, y para pagarlas juntas todos deben coincidir. Revisa tu selección o habla con tu ejecutivo para ajustar los datos.",
  "bill_billing_mismatch_child_panels": "paneles hijos",
  "bill_billing_mismatch_billing_data": "datos de facturación",
  "bill_review_invoices": "Revisar facturas",
  "bill_select_all_expired_invoices":
    "Para incluir facturas vigentes en el pago, debes seleccionar todas las facturas vencidas.",
  "bill_islr_page_title": "Retención de ISLR",
  "bill_islr_transport_title": "Servicios de transporte",
  "bill_islr_transport_info_tooltip":
    "Las retenciones para servicios de transporte se aplican automáticamente al 3% según la normativa vigente.",
  "bill_islr_transport_description":
    "Las retenciones para servicios de transporte se aplican automáticamente al 3% según la normativa vigente. Solo debes cargar los comprobantes de retención para continuar.",
  "bill_islr_third_party_title": "Servicio por cuenta de terceros",
  "bill_islr_third_party_info_tooltip":
    "Puedes activar la retención y definir el porcentaje aplicable según tu caso.",
  "bill_islr_third_party_description":
    "Si necesitas aplicar retención, actívala y elige el porcentaje correspondiente. Para continuar con el pago, es obligatorio cargar los comprobantes.",
  "bill_islr_retention_switch": "Retención",
  "bill_islr_col_invoice_no": "N° de factura",
  "bill_islr_col_retention_percent": "% Retención",
  "bill_islr_col_retention_amount_bs": "Monto de retención en Bs.",
  "bill_islr_col_retention_amount_usd": "Monto de retención en USD",
  "bill_islr_col_voucher": "Comprobante",
  "bill_islr_retention_amount_bs_tooltip": "Monto de retención expresado en bolívares.",
  "bill_islr_retention_amount_usd_tooltip": "Monto de retención expresado en dólares.",
  "bill_islr_upload": "Cargar",
  "bill_upload_retention_modal_title": "Asociar retención",
  "bill_upload_retention_file_label": "Retención",
  "bill_upload_retention_save": "Guardar",
  "bill_upload_retention_success": "Retención asociada correctamente",
  "bill_upload_retention_error": "Error al subir la retención",
  "bill_payment_status_update_alert_title":
    "Estamos actualizando el estado de tus pagos",
  "bill_payment_status_update_alert_body":
    "Es posible que algunas facturas aún no se reflejen como pagadas en tu historial. Si es tu caso, {highlight} y restablecer tu crédito disponible a la brevedad. Gracias por tu comprensión y confianza.",
  "bill_payment_status_update_alert_body_highlight":
    "nuestro equipo ya está trabajando para conciliar los pagos",
  "bill_error_loading_invoices": "Error al cargar las facturas",
  "bill_export_invoices_success": "Facturas exportadas exitosamente",
  "bill_export_invoices_error": "Error al exportar las facturas, intente más tarde",
  "bill_export_trips_success": "Viajes exportados exitosamente",
  "bill_export_trips_error": "Error al exportar los viajes, intente más tarde",
  "bill_invoice_trips_details_title": "Detalles de viajes y envíos",
  "bill_invoice_label": "Factura",
  "bill_islr_upload_retention_error": "Error al subir las retenciones, por favor intente nuevamente",
  "bill_islr_form_init_error":
    "Error inicializando el formulario, intente más tarde",
  "bill_islr_remove_expired_invoice_error":
    "Solo se puede remover facturas que no estén vencidas",
  "bill_islr_payment_summary_title": "Resumen de pago",
  "bill_islr_summary_transport_invoices": "Facturas por servicio de transporte",
  "bill_islr_summary_retention": "Retención",
  "bill_islr_summary_third_party_invoices": "Facturas por cuenta de terceros",
  "bill_islr_summary_total_invoices": "Total en facturas",
  "bill_islr_summary_total_retentions": "Total en retenciones",
  "bill_islr_summary_total_to_pay": "Total a pagar",
  "bill_islr_summary_includes_retentions": "(Incluye retenciones)",
  "bill_islr_continue_to_payment": "Continuar a pagos",
  "bill_islr_upload_all_vouchers_notice":
    "Debes cargar todos los comprobantes de retención antes de seleccionar el método de pago.",
  "bill_action_view_invoice": "Ver factura",
  "bill_action_view_trip_details": "Ver detalles de viajes",
  "bill_action_pay_invoice": "Pagar factura",
  "bill_action_view_payment_details": "Ver pagos y retenciones",
  "bill_action_view_details": "Ver detalles",
  "bill_action_view_credit_note": "Ver nota de crédito",
  "credit_note_title": "Nota de crédito",
  "credit_note_issue_date": "Fecha de emisión",
  "credit_note_origin_invoice": "Nro. factura de origen",
  "credit_note_status": "Estado",
  "credit_note_amount": "Monto",
  "credit_note_description": "Descripción",
  "credit_note_application_title": "Aplicación de la nota de crédito",
  "credit_note_invoice_number": "Nro. de factura",
  "credit_note_date": "Fecha",
  "credit_note_status_applied": "Aplicada",
  "credit_note_accept": "Aceptar",
  "dashboard_credit_blocked_tooltip":
    "Para poder continuar disfrutando del servicio, revisa tu límite de crédito con la persona responsable o paga en tus facturas vencidas",
  "monthly_metrics": "Métricas mensuales",

  // Change expired password view
  ChangeExpiredPassword: "Cambiar contraseña",
  "Your password has expired": "Tu contraseña ha vencido",
  "For security reasons you must set a new password before continuing":
    "Por seguridad debes establecer una nueva contraseña antes de continuar.",
  "Current password": "Contraseña actual",
  "New password": "Nueva contraseña",
  "Password changed successfully": "Contraseña cambiada exitosamente. Por favor inicia sesión nuevamente.",
  "Action not available in assist mode": "Esta acción no está disponible en modo asistencia",
  // Password policy checklist
  "At least 6 characters": "Al menos 6 caracteres",
  "At least one uppercase letter": "Al menos una letra mayúscula",
  "At least one lowercase letter": "Al menos una letra minúscula",
  "At least one number": "Al menos un número",
  "At least one symbol": "Al menos un símbolo (ej. @, #, !, $)",
  "Password requirements": "Requisitos de la contraseña",

  invoice_assistance_pill: "Actualización de facturación",
  invoice_assistance_title_highlight: "Esta semana ",
  invoice_assistance_title_rest: "no emitiremos facturas",
  invoice_assistance_step_pause_title: "Esta semana",
  invoice_assistance_step_pause_desc:
    "Pausamos la facturación mientras hacemos adecuaciones.",
  invoice_assistance_step_resume_title: "Lunes 9",
  invoice_assistance_step_resume_desc:
    "Retomamos la facturación y generamos tus facturas con todos los viajes realizados.",
  invoice_assistance_benefit_prefix: "Todos tus viajes de estos días ",
  invoice_assistance_benefit_highlight: "quedan registrados",
  invoice_assistance_benefit_suffix:
    " y se incluirán en tus facturas del lunes 9 de noviembre.",

  proforma_assistance_pill: "Nuevo modelo de facturación",
  proforma_assistance_title_prefix: "Desde el ",
  proforma_assistance_title_date: "lunes 9 de noviembre",
  proforma_assistance_title_suffix: ", primero recibirás una proforma",
  proforma_assistance_step_proforma_title: "Proforma",
  proforma_assistance_step_proforma_desc:
    "Te enviamos el monto de los viajes del período, en USD.",
  proforma_assistance_step_payment_title: "Pago",
  proforma_assistance_step_payment_desc:
    "Pagas el total de la proforma desde tu panel.",
  proforma_assistance_step_invoice_title: "Factura",
  proforma_assistance_step_invoice_desc:
    "Emitimos tu factura fiscal a la tasa BCV del día del pago.",
  proforma_assistance_benefit_prefix: "Así tu factura refleja ",
  proforma_assistance_benefit_highlight: "exactamente lo que pagaste",
  proforma_assistance_benefit_suffix:
    ", sin diferencias por tipo de cambio.",
  proforma_assistance_note:
    "Podrás cargar tus comprobantes de retención una vez emitida la factura.",
  proforma_assistance_footer_question:
    "¿Aún tienes dudas o quieres más información?",
  proforma_assistance_contact: "Quiero que me contacten",
  proforma_assistance_understood: "Entendido",
  proforma_assistance_contact_success_intro:
    "Registramos su solicitud de asistencia.",
  proforma_assistance_contact_success: "Nos comunicaremos contigo en breve",
  proforma_assistance_error:
    "No pudimos guardar tu respuesta. Inténtalo de nuevo.",
  proforma_assistance_auto_require_invalid: "Peticion invalida",
  proforma_assistance_auto_require_error:
    "Error registrando su solicitud, intente mas tarde",
};
